import { render, staticRenderFns } from "./ElementsTree.vue?vue&type=template&id=5721db48&scoped=true&"
import script from "./ElementsTree.vue?vue&type=script&lang=js&"
export * from "./ElementsTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5721db48",
  null
  
)

export default component.exports